module.exports = __webpack_public_path__ + "img/inventory_list_2.4958ca73.png";